import * as React from 'react';
import './Spreadsheet.css';
import ProductModel, { getProduct } from '../../domain/Product';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import ApplicationState from '../../application/core/State';
import { connect } from 'react-redux';
import { ArticleOrderDraft } from '../../domain/Order';
import SpreadsheetProduct from './SpreadsheetProduct';
import Order from '../../domain/Order';
import SpreadsheetOrderDetails from './SpreadsheetOrderDetails';

interface Props {
    headers: string[];
    month: string;
}

interface StateProps {
    order: Order;
    products: ProductModel[];
}

class Spreadsheet extends React.PureComponent<StateProps & DispatchProps & Props> {
    public render(): JSX.Element {
        return (
            <div className="spreadsheet">
                <div className="spreadsheet-table">
                    <div className="spreadsheet-table-header">
                        <div className="spreadsheet-table-header-product">
                            {this.props.headers.map(name => (
                                <div>
                                    <span>{name}</span>
                                </div>
                            ))}
                        </div>

                        <div className="spreadsheet-table-header-order">
                            <div />
                            <div>
                                <span>Estim.</span>
                            </div>
                            <div>
                                <span>Ordered</span>
                            </div>
                            <div>
                                <span>{this.props.month}</span>
                            </div>
                            <div>
                                <span>Stock order</span>
                            </div>
                        </div>
                    </div>
                    <div className="spreadsheet-table-body">
                        {// todo it will crash when there is no product for given order
                        this.props.order.articlesOrdersDrafts.map((order: ArticleOrderDraft) => (
                            <div className="spreadsheet-table-row" key={order.articleId}>
                                <SpreadsheetProduct product={getProduct(this.props.products, order.articleId)} key={order.articleId} />
                                <SpreadsheetOrderDetails
                                    product={getProduct(this.props.products, order.articleId)}
                                    model={order.itemsOrdersDrafts}
                                    month={this.props.order.month}
                                    packageSize={6}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    products: state.products.orderProducts,
    order: state.order.order!
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Spreadsheet);



// WEBPACK FOOTER //
// ./src/view/order/Spreadsheet.tsx